// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import {getAuth} from 'firebase/auth';
import {GoogleAuthProvider} from 'firebase/auth';
import {getFirestore} from 'firebase/firestore';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD867RVVCdJespaIhgSVFeU6jSwB02VuKM",
  authDomain: "ssg-services.firebaseapp.com",
  projectId: "ssg-services",
  storageBucket: "ssg-services.appspot.com",
  messagingSenderId: "389201600360",
  appId: "1:389201600360:web:92cc0a2032ba74418680dd",
  measurementId: "G-4ECQMEDMKD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const db = getFirestore(app);
export {auth, provider, db};